import React from 'react';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import escape from 'lodash/escape';

const t = withLocalePrefix('talent_matching.document_viewer_modal');

type Props = {
  displayName: string;
  sourceUrl: string | undefined;
  fileType: string | null;
};

const ImageDisplay = ({
  displayName,
  sourceUrl,
}: {
  displayName: string;
  sourceUrl: string;
}) => {
  const sourceDocument = `
      <html>
        <head><style>body { margin: 0; } img { width: 100%; height: auto; }</style></head>
        <body><img src="${sourceUrl}" /></body>
      </html>
    `;

  return (
    <iframe
      aria-label={displayName}
      data-provides="document-entrypoint"
      srcDoc={sourceDocument}
      className="pii-blur"
    />
  );
};

const TextDisplay = ({
  displayName,
  sourceUrl,
}: {
  displayName: string;
  sourceUrl: string;
}) => {
  const [textContent, setTextContent] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchTextContent = async () => {
      try {
        const response = await fetch(sourceUrl);
        const text = await response.text();
        setTextContent(text);
      } catch (error) {
        setTextContent(t('preview_not_available'));
      }
    };

    fetchTextContent();
  }, [sourceUrl]);

  const srcDoc = `<style>pre { margin: 0; white-space: pre-wrap; font-family: monospace; }</style>
    <pre>${escape(textContent || '')}</pre>`;

  return (
    <iframe
      aria-label={displayName}
      data-provides="document-entrypoint"
      srcDoc={srcDoc}
      className="pii-blur"
    />
  );
};

const DocPreviewDisplay = ({
  displayName,
  sourceUrl,
}: {
  displayName: string;
  sourceUrl: string;
}) => {
  return (
    <iframe
      aria-label={displayName}
      data-provides="document-entrypoint"
      src={sourceUrl}
      className="pii-blur"
    />
  );
};

const DocumentDisplay = ({ displayName, sourceUrl, fileType }: Props) => {
  if (!sourceUrl) {
    return <Body>{t('preview_not_available')}</Body>;
  } else if (fileType === 'image') {
    return <ImageDisplay displayName={displayName} sourceUrl={sourceUrl} />;
  } else if (fileType === 'text') {
    return <TextDisplay displayName={displayName} sourceUrl={sourceUrl} />;
  } else {
    return (
      <DocPreviewDisplay displayName={displayName} sourceUrl={sourceUrl} />
    );
  }
};

export default DocumentDisplay;
